<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue'
import { useForm, useToast } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'
import { newCompany, updateCompanyById } from '../../../core/requests/Company'
import { validators } from '../../../services/utils'
import { onlyNumbersNoDigits } from '../../../core/helpers'

const emit = defineEmits(['close'])

const vOnlyNumbers = onlyNumbersNoDigits

const props = defineProps({
  data: {
    default: null,
    type: Object,
  },
})

const { t } = useI18n()
const isLoading = ref(false)
const { isValid, validate, reset } = useForm('formRef')
const form: any = reactive({})
const { notify } = useToast()

onMounted(() => {
  if (props.data) {
    form.socialreason = props.data?.socialreason
    form.ruc = props.data?.ruc
    form.whatsapp = props.data?.whatsapp
    form.phone = props.data?.phone
    form.address = props.data?.address
  }
})

const doProcess = async () => {
  if (validate()) {
    isLoading.value = true
    try {
      if (props.data) {
        await updateCompanyById(props.data?.id, form)

        notify({
          message: 'Emnpresa actualizada correctamente',
          color: 'success',
        })
      } else {
        await newCompany(form)

        notify({
          message: 'Emnpresa registrada correctamente',
          color: 'success',
        })

        reset()
      }

      emit('close')
    } catch (e: any) {
      console.log(e)
    }

    isLoading.value = false
  }
}
const openSunatRuc = () => {
  window.open(
    'https://e-consultaruc.sunat.gob.pe/cl-ti-itmrconsruc/FrameCriterioBusquedaWeb.jsp',
    '_blank',
    'menubar=1,resizable=0,width=600,height=500',
  )
}
</script>

<template>
  <div class="bg-blue-50">
    <div class="mb-4">
      <div class="flex justify-between align-center justify-center">
        <h1 class="h5 font-bold m-0">{{ t('contacts.newCompany') }}</h1>
      </div>
    </div>

    <div class="new-customer gap-8">
      <VaForm v-if="!$props.data || form.socialreason" ref="formRef" immediate class="gap-2">
        <div class="w-full bg-white p-2 mt-3 mb-4 py-5">
          <div class="gap-2">
            <div class="w-full columns-1">
              <div class="w-full">
                <VaInput
                  v-model="form.socialreason"
                  maxlength="40"
                  stateful
                  clearable
                  name="company_socialreason"
                  label="Razón social"
                  :rules="[validators.required]"
                />
              </div>

              <div class="w-full mt-2">
                <!-- <ImpalaRuc :model="form.ruc" @complete="(e) => (form.ruc = e)" /> -->
                <VaInput
                  v-model="form.ruc"
                  v-only-numbers
                  maxlength="20"
                  name="ruc"
                  stateful
                  clearable
                  label="RUC"
                  :rules="[validators.required]"
                >
                  <template #appendInner>
                    <VaIcon name="open_in_new" class="cursor-pointer" @click="openSunatRuc()" />
                  </template>
                </VaInput>
              </div>
            </div>

            <div class="columns-2 mt-3">
              <div class="w-full">
                <VaInput
                  v-model="form.phone"
                  v-only-numbers
                  stateful
                  clearable
                  maxlength="12"
                  name="company_phone"
                  label="Teléfono"
                >
                  <template #prependInner>
                    <VaIcon name="call" class="material-symbols-outlined -mx-1.5" color="secondary" />
                  </template>
                </VaInput>
              </div>
              <div class="w-full">
                <VaInput
                  v-model="form.whatsapp"
                  v-only-numbers
                  stateful
                  maxlength="12"
                  clearable
                  name="company_whatsapp"
                  label="WhatsApp"
                >
                  <template #prependInner>
                    <VaIcon name="call" class="material-symbols-outlined -mx-1.5" color="secondary" />
                  </template>
                </VaInput>
              </div>
            </div>

            <div class="columns-1 mt-3">
              <div class="w-full">
                <VaInput
                  v-model="form.address"
                  stateful
                  clearable
                  maxlength="50"
                  name="company_address"
                  label="Dirección de contacto"
                />
              </div>
            </div>
          </div>
        </div>
      </VaForm>
    </div>

    <div class="pb-3">
      <div class="flex justify-end">
        <div class="flex gap-2">
          <VaButton icon="save" color="primary" :disabled="!isValid" :loading="isLoading" @click="doProcess">
            <span class="text-xs px-1">{{ props.data ? 'Actualizar empresa' : t('contacts.createCompany') }}</span>
          </VaButton>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.new-customer {
  &-tabs {
    .va-tabs__content {
      width: 100%;
    }
  }

  .float-profile {
    position: absolute;
    top: 0;
    right: 0;
  }
}
</style>
